<template>
  <div>
    <Movementmenu />

    <v-container fluid class="pa-6" tag="section">
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between mb-2">
            <div>
              <h2 class="text-h4 font-weight-bold primary--text">
                <v-icon large color="primary" class="mr-2"
                  >mdi-swap-horizontal-circle</v-icon
                >
                ประมวลผลการย้าย: แบบที่ 4 (สับเปลี่ยนไม่ปกติ)
              </h2>
              <div class="subtitle-1 grey--text text--darken-1 mt-1">
                ระบบจับคู่และตรวจสอบคุณสมบัติการสับเปลี่ยนต่างสาขา/ต่างเงื่อนไข
              </div>
            </div>
            <v-btn
              color="indigo"
              dark
              large
              rounded
              elevation="3"
              @click="Switch_personnelAll()"
              :loading="loading"
            >
              <v-icon left>mdi-refresh</v-icon> ประมวลผลใหม่
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #1976D2"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รายการทั้งหมด</div>
                <div class="text-h4 font-weight-bold">{{ stats.total }}</div>
              </div>
              <v-avatar color="blue lighten-5" size="60">
                <v-icon color="blue" x-large>mdi-format-list-bulleted</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #4CAF50"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">ดำเนินการสำเร็จ</div>
                <div class="text-h4 font-weight-bold success--text">
                  {{ stats.completed }}
                </div>
              </div>
              <v-avatar color="green lighten-5" size="60">
                <v-icon color="success" x-large
                  >mdi-check-circle-outline</v-icon
                >
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #FB8C00"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">รอตรวจสอบ/เงื่อนไข</div>
                <div class="text-h4 font-weight-bold warning--text">
                  {{ stats.pending }}
                </div>
              </div>
              <v-avatar color="orange lighten-5" size="60">
                <v-icon color="warning" x-large
                  >mdi-alert-circle-check-outline</v-icon
                >
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg pa-4"
            elevation="2"
            border="left"
            style="border-left: 5px solid #FF5252"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-overline grey--text">
                  รายการรับย้าย (Demand)
                </div>
                <div class="text-h4 font-weight-bold error--text">
                  {{ stats.demand }}
                </div>
              </div>
              <v-avatar color="red lighten-5" size="60">
                <v-icon color="error" x-large>mdi-hand-heart</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-card elevation="2" class="rounded-lg">
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="ค้นหาชื่อ, วิทยาลัย, สาขา หรือรหัส..."
            single-line
            hide-details
            outlined
            dense
            rounded
            class="mr-4"
            style="max-width: 400px;"
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn color="success" outlined class="mr-2" @click="exportToExcel">
            <v-icon left>mdi-file-excel</v-icon> Export Excel
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <v-data-table
          v-model="select_item"
          :headers="headers"
          :items="conditions_transfers"
          :search="search"
          :loading="loading"
          :items-per-page="10"
          class="elevation-0"
        >
          <template v-slot:header.college_name_a="{ header }">
            <div class="text-center teal--text text--darken-2 pl-2 border-left">
              <v-icon small color="teal darken-2">mdi-account</v-icon>
              ข้อมูลฝั่ง A
            </div>
          </template>
          <template v-slot:header.college_name_b="{ header }">
            <div class="text-center indigo--text text--darken-2 pl-2">
              <v-icon small color="indigo darken-2">mdi-account-switch</v-icon>
              ข้อมูลฝั่ง B
            </div>
          </template>

          <template v-slot:item.select_item="{ item }">
            <v-checkbox
              v-model="selected"
              :value="item.id_card_a"
              color="primary"
            ></v-checkbox>
          </template>

          <template v-slot:item.details_a="{ item }">
            <div class="d-flex flex-column py-3">
              <span class="font-weight-bold text-subtitle-2">{{
                item.personnel_name_a
              }}</span>
              <span class="caption grey--text"
                ><v-icon x-small>mdi-card-account-details</v-icon>
                {{ item.id_card_a }}</span
              >
              <v-chip
                x-small
                color="teal lighten-5"
                text-color="teal darken-3"
                class="mt-1"
                style="width: fit-content;"
              >
                <v-icon x-small left>mdi-school</v-icon>
                {{ item.college_name_a }}
              </v-chip>
              <span class="caption mt-1 primary--text"
                >สาขา: {{ item.name_branch }}</span
              >
            </div>
          </template>

          <template v-slot:item.status_process="{ item }">
            <div class="d-flex justify-center align-center">
              <v-icon v-if="item.college_code_susss >= 1" color="success"
                >mdi-check-circle</v-icon
              >
              <v-icon v-else color="grey lighten-1">mdi-swap-horizontal</v-icon>
            </div>
          </template>

          <template v-slot:item.details_b="{ item }">
            <div class="d-flex flex-column py-3 text-right">
              <span class="font-weight-bold text-subtitle-2">{{
                item.personnel_name_b
              }}</span>
              <span class="caption grey--text"
                >{{ item.id_card_b }}
                <v-icon x-small>mdi-card-account-details</v-icon></span
              >
              <div class="d-flex justify-end">
                <v-chip
                  x-small
                  color="indigo lighten-5"
                  text-color="indigo darken-3"
                  class="mt-1"
                >
                  {{ item.college_name_b }}
                  <v-icon x-small right>mdi-school</v-icon>
                </v-chip>
              </div>
            </div>
          </template>

          <template v-slot:item.college_code_susss="{ item }">
            <div class="text-center">
              <v-chip
                v-if="item.college_code_susss >= 1"
                color="success"
                text-color="white"
                small
                label
              >
                <v-icon left small>mdi-check</v-icon> บันทึกแล้ว
              </v-chip>
              <v-chip
                v-else-if="
                  item.status_select_a === 'demand' ||
                    item.status_select_b === 'demand'
                "
                color="warning"
                text-color="white"
                small
                label
              >
                รับย้าย
              </v-chip>
              <v-chip
                v-else
                color="grey lighten-2"
                text-color="grey darken-2"
                small
                label
              >
                รออนุมัติ
              </v-chip>
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-center">
              <v-tooltip bottom v-if="item.college_code_susss >= 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="
                      deletePosition(item.id_ref, item.id_ref_b, item.id_branch)
                    "
                  >
                    <v-icon>mdi-delete-circle</v-icon>
                  </v-btn>
                </template>
                <span>ยกเลิกรายการนี้</span>
              </v-tooltip>

              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="green"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="
                      select_idPosition(
                        item.id_ref,
                        item.id_ref_b,
                        item.id_branch
                      )
                    "
                  >
                    <v-icon>mdi-content-save-edit</v-icon>
                  </v-btn>
                </template>
                <span>บันทึก/จับคู่สลับ</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:no-data>
            <div class="text-center pa-5">
              <v-icon large color="grey lighten-2"
                >mdi-database-search-off</v-icon
              >
              <div class="grey--text mt-2">
                ไม่พบข้อมูลการสับเปลี่ยนแบบที่ 4
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="canceldialog" persistent max-width="900px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar color="red lighten-1" dark flat>
            <v-icon class="mr-2">mdi-alert-circle</v-icon> ยืนยันการยกเลิกรายการ
            (แบบที่ 4)
            <v-spacer></v-spacer>
            <v-btn icon @click="canceldialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-alert type="warning" text dense border="left" class="mb-4">
              ข้อมูลที่ถูกจับคู่แล้วจะถูกลบออกจากระบบผลสำเร็จ
              กรุณาตรวจสอบก่อนดำเนินการ
            </v-alert>
            <v-row>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-4 fill-height border-success">
                  <div class="text-overline teal--text">ข้อมูลฝั่ง A</div>
                  <v-divider class="mb-3"></v-divider>
                  <div class="font-weight-bold text-h6">
                    {{ transference_personnels.title_s
                    }}{{ transference_personnels.frist_name }}
                    {{ transference_personnels.last_name }}
                  </div>
                  <div class="text-body-2 grey--text mb-2">
                    ID: {{ transference_personnels.id_card }}
                  </div>
                  <div class="text-body-2">
                    <v-icon small color="teal">mdi-school</v-icon>
                    {{ transference_personnels.college_name }}
                  </div>
                  <div class="text-body-2 mt-1">
                    <v-icon small>mdi-bookmark</v-icon> สาขา:
                    {{ branchs.name_branch }}
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-4 fill-height border-info">
                  <div class="text-overline indigo--text">
                    ข้อมูลฝั่ง B (คู่สลับ)
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <div class="font-weight-bold text-h6">
                    {{ transference_personnels_b.title_s
                    }}{{ transference_personnels_b.frist_name }}
                    {{ transference_personnels_b.last_name }}
                  </div>
                  <div class="text-body-2 grey--text mb-2">
                    ID: {{ transference_personnels_b.id_card }}
                  </div>
                  <div class="text-body-2">
                    <v-icon small color="indigo">mdi-school</v-icon>
                    {{ transference_personnels_b.college_name }}
                  </div>
                  <div class="text-body-2 mt-1">
                    <v-icon small>mdi-bookmark</v-icon> สาขา:
                    {{ branchs.name_branch }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="canceldialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn color="red" dark elevation="2" @click="cancelSubmit">
              <v-icon left>mdi-delete</v-icon> ยืนยันการลบ
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="positiondialog" persistent max-width="900px">
        <v-card class="rounded-xl overflow-hidden">
          <v-toolbar color="teal darken-1" dark flat>
            <v-icon class="mr-2">mdi-content-save-move</v-icon>
            บันทึกการสับเปลี่ยนตำแหน่ง
            <v-spacer></v-spacer>
            <v-btn icon @click="positiondialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card-text class="pt-6">
            <v-form ref="updatepositionform" lazy-validation>
              <v-row>
                <v-col cols="12" md="6">
                  <v-card elevation="0" color="teal lighten-5" class="pa-4">
                    <div class="d-flex align-center mb-2">
                      <v-avatar color="teal" size="30" class="mr-2"
                        ><span class="white--text font-weight-bold"
                          >A</span
                        ></v-avatar
                      >
                      <span class="font-weight-bold text-h6">ผู้ย้าย</span>
                    </div>
                    <div class="pl-10">
                      <div class="text-h6">
                        {{ transference_personnels.title_s
                        }}{{ transference_personnels.frist_name }}
                        {{ transference_personnels.last_name }}
                      </div>
                      <div class="caption grey--text mb-2">
                        จาก: {{ transference_personnels.college_name }}
                      </div>
                      <v-divider class="my-2"></v-divider>
                      <div class="subtitle-2">
                        ตำแหน่งเลขที่: {{ transference_personnels.id_position }}
                      </div>
                      <div class="subtitle-2 primary--text">
                        สาขาที่สับเปลี่ยน: {{ branchs.name_branch }}
                      </div>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card elevation="0" color="indigo lighten-5" class="pa-4">
                    <div class="d-flex align-center mb-2">
                      <v-avatar color="indigo" size="30" class="mr-2"
                        ><span class="white--text font-weight-bold"
                          >B</span
                        ></v-avatar
                      >
                      <span class="font-weight-bold text-h6">คู่สลับ</span>
                    </div>
                    <div class="pl-10">
                      <div class="text-h6">
                        {{ transference_personnels_b.title_s
                        }}{{ transference_personnels_b.frist_name }}
                        {{ transference_personnels_b.last_name }}
                      </div>
                      <div class="caption grey--text mb-2">
                        จาก: {{ transference_personnels_b.college_name }}
                      </div>
                      <v-divider class="my-2"></v-divider>
                      <div class="subtitle-2">
                        ตำแหน่งเลขที่:
                        {{ transference_personnels_b.id_position }}
                      </div>
                      <div class="subtitle-2 primary--text">
                        สาขาที่สับเปลี่ยน: {{ branchs.name_branch }}
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions class="grey lighten-5 pa-4">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="positiondialog = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="success"
              dark
              elevation="2"
              @click="updatepositionSubmit"
            >
              <v-icon left>mdi-check</v-icon> บันทึกข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
      elevation="4"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2" dark>{{ snackbar.icon }}</v-icon>
        <span class="white--text">{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="snackbar.show = false"
          >ปิด</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // Requires: npm install xlsx
import { saveAs } from "file-saver"; // Requires: npm install file-saver

export default {
  name: "HrvecProcessTransferType4",
  components: { Movementmenu },
  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      search: "",
      select_item: [],
      selected: [],

      // Dialog Controls
      canceldialog: false,
      positiondialog: false,
      deletetransference_locationdialog: false,

      // Data Holders
      conditions_transfers: [],
      period_match: {},
      transference_personnels: {}, // Person A
      transference_personnels_b: {}, // Person B
      branchs: {},
      man_powers: [],

      conditons_transfer_successs: [],
      conditons_transfer_successs_b: [],

      // Forms
      updatepositions: {},
      updatepositions_b: {},

      // UI
      snackbar: {
        show: false,
        color: "",
        timeout: 4000,
        icon: "",
        text: ""
      },
      // Headers Refactored for Grouping
      headers: [
        { text: "เลือก", value: "select_item", sortable: false, width: "50px" },
        {
          text: "รายละเอียดผู้ย้าย (A)",
          value: "details_a",
          sortable: false,
          align: "left"
        },
        {
          text: "",
          value: "status_process",
          sortable: false,
          align: "center",
          width: "50px"
        },
        {
          text: "รายละเอียดคู่สลับ (B)",
          value: "details_b",
          sortable: false,
          align: "right"
        },
        {
          text: "สถานะรายการ",
          value: "college_code_susss",
          align: "center",
          width: "120px"
        },
        {
          text: "จัดการ",
          value: "actions",
          sortable: false,
          align: "center",
          width: "120px"
        }
      ]
    };
  },
  computed: {
    // Statistics for the dashboard
    stats() {
      const total = this.conditions_transfers.length;
      const completed = this.conditions_transfers.filter(
        item => item.college_code_susss >= 1
      ).length;
      const demand = this.conditions_transfers.filter(
        item =>
          item.status_select_a === "demand" || item.status_select_b === "demand"
      ).length;
      const pending = total - completed - demand; // Approximation

      return { total, completed, demand, pending };
    }
  },
  async mounted() {
    await this.initializeData();
  },
  methods: {
    async initializeData() {
      await this.period_QueryAll();
      await this.Switch_personnelAll();
    },

    // --- API Calls ---
    async period_QueryAll() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable_process: "1",
          period_id: "301"
        });
        this.period_match = result.data;
      } catch (e) {
        console.error("Error fetching period:", e);
      }
    },

    async Switch_personnelAll() {
      this.loading = true;
      try {
        let result = await this.$http.post("process_transfer.php", {
          ApiKey: this.ApiKey,
          time_s: this.period_match.period_times,
          year_s: this.period_match.period_year,
          switchs: "Ok" // Specific for Type 4
        });
        this.conditions_transfers = result.data;
      } catch (e) {
        this.showSnackbar("error", "เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.loading = false;
      }
    },

    async man_powerQuery(college_code) {
      // Optional: Keep logic if needed for sidebar/other components
      if (!college_code) return;
      let result = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        college_code: college_code
      });
      this.man_powers = result.data;
    },

    async select_idPosition(id_ref, id_ref_b, id_branch) {
      this.loading = true;
      try {
        // 1. Get Person A
        let res_tran_a = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels = res_tran_a.data;

        // 2. Get Person B
        let res_tran_b = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref_b
        });
        this.transference_personnels_b = res_tran_b.data;

        // 3. Get Branch Info
        let res_branch = await this.$http.post("branch.php", {
          ApiKey: this.ApiKey,
          id_branch: id_branch
        });
        this.branchs = res_branch.data;

        this.positiondialog = true;
        // Optionally update manpower context
        if (this.conditions_branchs && this.conditions_branchs.college_code) {
          this.man_powerQuery(this.conditions_branchs.college_code);
        }
      } catch (e) {
        this.showSnackbar("error", "ดึงข้อมูลล้มเหลว");
      } finally {
        this.loading = false;
      }
    },

    async updatepositionSubmit() {
      if (!this.$refs.updatepositionform.validate()) return;

      this.loading = true;
      try {
        // Payload A
        const payloadA = {
          ApiKey: this.ApiKey,
          ctstime_s: this.transference_personnels.time_ss,
          ctsyear_s: this.transference_personnels.year_ss,
          ctsid_postion_old: this.transference_personnels.id_position,
          ctscollege_code_old: this.transference_personnels.college_code,
          ctsid_card: this.transference_personnels.id_card,
          ctsid_ref: this.transference_personnels.tid_ref,
          ctsname_position: "ครู",
          ctscollege_code: this.transference_personnels_b.college_code, // Go to B's college
          ctsid_position: this.transference_personnels_b.id_position, // Take B's position
          ctsid_branch: this.branchs.id_branch,
          ctsstatus_select: "sw_agree"
        };

        // Payload B
        const payloadB = {
          ApiKey: this.ApiKey,
          ctstime_s: this.transference_personnels_b.time_ss,
          ctsyear_s: this.transference_personnels_b.year_ss,
          ctsid_postion_old: this.transference_personnels_b.id_position,
          ctscollege_code_old: this.transference_personnels_b.college_code,
          ctsid_card: this.transference_personnels_b.id_card,
          ctsid_ref: this.transference_personnels_b.tid_ref,
          ctsname_position: "ครู",
          ctscollege_code: this.transference_personnels.college_code, // Go to A's college
          ctsid_position: this.transference_personnels.id_position, // Take A's position
          ctsid_branch: this.branchs.id_branch,
          ctsstatus_select: "sw_agree"
        };

        let resA = await this.$http.post(
          "conditons_transfer_success.insert.php",
          payloadA
        );
        let resB = await this.$http.post(
          "conditons_transfer_success.insert.php",
          payloadB
        );

        if (resA.data.status === true && resB.data.status === true) {
          this.showSnackbar("success", "บันทึกการสับเปลี่ยนเรียบร้อยแล้ว");
          this.positiondialog = false;
          this.Switch_personnelAll();
        } else {
          this.showSnackbar(
            "warning",
            "การบันทึกข้อมูลมีปัญหา กรุณาลองใหม่อีกครั้ง"
          );
        }
      } catch (e) {
        this.showSnackbar("error", "Server Error: ไม่สามารถบันทึกได้");
      } finally {
        this.loading = false;
      }
    },

    async deletePosition(id_ref, id_ref_b, id_branch) {
      this.loading = true;
      try {
        // Fetch context data again for safety
        let res_tran_a = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref
        });
        this.transference_personnels = res_tran_a.data;

        let res_tran_b = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: id_ref_b
        });
        this.transference_personnels_b = res_tran_b.data;

        let res_branch = await this.$http.post("branch.php", {
          ApiKey: this.ApiKey,
          id_branch: id_branch
        });
        this.branchs = res_branch.data;

        // Fetch Success Records to delete
        let res_cts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: id_ref
        });
        this.conditons_transfer_successs = res_cts.data;

        let res_cts_b = await this.$http.post(
          "conditons_transfer_success.php",
          { ApiKey: this.ApiKey, ctsid_ref: id_ref_b }
        );
        this.conditons_transfer_successs_b = res_cts_b.data;

        this.canceldialog = true;
      } catch (e) {
        this.showSnackbar("error", "ไม่สามารถดึงข้อมูลเพื่อการลบได้");
      } finally {
        this.loading = false;
      }
    },

    async cancelSubmit() {
      this.loading = true;
      try {
        this.conditons_transfer_successs.ApiKey = this.ApiKey;
        this.conditons_transfer_successs_b.ApiKey = this.ApiKey;

        let res_del_a = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs
        );
        let res_del_b = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs_b
        );

        if (res_del_a.data.status === true && res_del_b.data.status === true) {
          this.showSnackbar("success", "ยกเลิกข้อมูลสำเร็จ");
          this.canceldialog = false;
          this.Switch_personnelAll();
        } else {
          this.showSnackbar("error", "การยกเลิกไม่สมบูรณ์");
        }
      } catch (e) {
        this.showSnackbar("error", "Server Error ในการลบข้อมูล");
      } finally {
        this.loading = false;
      }
    },

    // --- Helpers ---
    showSnackbar(color, text) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.icon =
        color === "success" ? "mdi-check-circle" : "mdi-alert-circle";
      this.snackbar.show = true;
    },

    exportToExcel() {
      // 1. Prepare Data
      const exportData = this.conditions_transfers.map(item => ({
        "ID A": item.id_card_a,
        "ชื่อ-สกุล A": item.personnel_name_a,
        "วิทยาลัย A": item.college_name_a,
        "ID B": item.id_card_b,
        "ชื่อ-สกุล B": item.personnel_name_b,
        "วิทยาลัย B": item.college_name_b,
        สาขา: item.name_branch,
        สถานะ: item.college_code_susss >= 1 ? "ดำเนินการแล้ว" : "รออนุมัติ"
      }));

      // 2. Create Sheet & Workbook
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Abnormal_Switch");

      // 3. Write and Download
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });

      saveAs(
        data,
        `Transfer_Switch_Type4_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    },

    // Existing helper
    getColor(status) {
      if (status > 0) return "green";
      return "";
    }
  }
};
</script>

<style scoped>
.border-left {
  border-left: 4px solid #00695c; /* Teal Darken 3 */
}
::v-deep .v-data-table__wrapper tr:hover {
  background-color: #fafafa !important;
}
/* Card Borders for Dialog */
.border-success {
  border-top: 4px solid #26a69a;
}
.border-info {
  border-top: 4px solid #5c6bc0;
}
</style>
